import { render, staticRenderFns } from "./MyBook.vue?vue&type=template&id=7fdce016&scoped=true&"
import script from "./MyBook.vue?vue&type=script&lang=js&"
export * from "./MyBook.vue?vue&type=script&lang=js&"
import style0 from "./MyBook.vue?vue&type=style&index=0&id=7fdce016&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdce016",
  null
  
)

export default component.exports